import { lazy } from 'react';

const AccountEdit = lazy(() => import('./AccountEdit'));

export default AccountEdit;
